/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#datepick3[_ngcontent-%COMP%]   .mydp[_ngcontent-%COMP%]   .selectiongroup[_ngcontent-%COMP%]{border:none!important}.custom-checkbox[_ngcontent-%COMP%]   .datepick[_ngcontent-%COMP%]{position:absolute;right:10px;top:20px}"];
export { styles as styles };

